module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "onboarding-modal"
    }
  }, [_c('div', {
    staticClass: "onboarding-modal"
  }, [(_vm.hasMask) ? _c('div', {
    staticClass: "onboarding-modal__mask",
    on: {
      "click": _vm.clickMask
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "onboarding-modal__wrapper"
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasX) ? _c('div', {
    staticClass: "onboarding-modal__x",
    on: {
      "click": _vm.clickX
    }
  }, [_vm._v("×")]) : _vm._e()], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07cec41f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/partials/OnboardingModal.vue
// module id = 1806
// module chunks = 0